import { useState, useEffect } from 'react';

/**
 * Hook care amână actualizarea unei valori până când a trecut
 * un timp specificat fără ca acea valoare să se mai schimbe.
 * Ideal pentru auto-save sau funcții de căutare live.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Setează un timer care va actualiza valoarea
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Curăță timer-ul dacă valoarea se schimbă din nou
    // înainte ca timer-ul să se fi terminat
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}